import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from "@core-app/layout/main/main.component";
import {PageComponent} from "@gallaghercp/core-frontend";
import {LayoutModule} from './layout/layout.module';

export const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        children: [
            {
                path: '',
                component: PageComponent,
            },
        ]
    },
    {
        path: '**',
        redirectTo: '/',
    }
];

@NgModule({
    imports: [
        LayoutModule,
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
        })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {

}
